import { render, staticRenderFns } from "./TalkBranch.vue?vue&type=template&id=a3971d1c&scoped=true&"
import script from "./TalkBranch.vue?vue&type=script&lang=ts&"
export * from "./TalkBranch.vue?vue&type=script&lang=ts&"
import style0 from "./TalkBranch.vue?vue&type=style&index=0&id=a3971d1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3971d1c",
  null
  
)

export default component.exports